import { Column } from 'primereact/column';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ButtonDelete, ButtonEdit } from '../../../components/Buttons';
import { PaginatedDataTable } from '../../../components/PaginatedDataTable';
import { formatDatetime } from '../../../utils/date';

export const VoteTable = ({ votes, loading, onClickDelete, disabled }) => {
    const { municipalityId, bodyType, termId, meetingId } = useParams();

    const navigate = useNavigate();

    const edited = votes?.some(vote => vote.edited);

    const buttonsTemplate = (rowData) => {
        return (
            <div className='table-buttons'>
                <ButtonEdit
                    rounded
                    title='Editovat hlasování'
                    disabled={disabled}
                    onClick={() =>
                        navigate(
                            `/admin/municipality/${municipalityId}/${bodyType}/funkcni-obdobi/${termId}/zasedani/${meetingId}/hlasovani/${rowData.id}`
                        )
                    }
                />
                <ButtonDelete
                    rounded
                    title='Smazat hlasování'
                    disabled={disabled}
                    onClick={() => onClickDelete(rowData)}
                />
            </div>
        );
    };

    const timeTemplate = (rowData) => {
        return formatDatetime(new Date(rowData.time));
    }

    return (
        <PaginatedDataTable
            value={votes}
            loading={loading}
            removableSort
            breakpoint='500px'
            emptyMessage='Zasedání neobsahuje žádná hlasování'
        >
            <Column field='number' header='Číslo' sortable />
            <Column field='time' header='Čas' body={timeTemplate} sortable />
            {
                edited &&
                <Column 
                    field='edited'
                    body={(rowData) => (rowData.edited ?
                        <span
                            className='pi pi-book vote-list-edit-icon'
                            title='Hlasování bylo upraveno'
                        /> :
                        null
                    )}
                />
            }
            <Column field='item' header='Předmět' sortable />
            <Column body={buttonsTemplate} align='right' />
        </PaginatedDataTable>
    );
};
